/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { LoggingSettings } from '@modules/cloud-api/v1/types'
import type { LoggerLevel, AsyncRequestState } from '@modules/ui-types'

import { getAdminconsoleLoggingSettings } from '@/reducers/adminconsoleLoggingSettings'
import {
  patchAdminconsoleLoggingSettingsRequest,
  fetchAdminconsoleLoggingSettingsRequest,
} from '@/reducers/asyncRequests/registry'

import ZkLoggingSettingsButton from '../ZkLoggingSettingsButton'
import {
  fetchAdminconsoleLoggingSettings,
  patchAdminconsoleLoggingSettings,
} from '../../actions/adminconsoles'

import type { ReduxState } from '@/types/redux'

type PatchLoggingLevels = {
  [key: string]: LoggerLevel | null
}

type StateProps = {
  loggingSettings: LoggingSettings | null
  fetchLoggingSettingsRequest: AsyncRequestState
  patchLoggingSettingsRequest: AsyncRequestState
}

type DispatchProps = {
  fetchLoggingSettings: () => void
  patchLoggingSettings: (settings: { loggingLevels: PatchLoggingLevels }) => Promise<void>
}

type ConsumerProps = {
  regionId: string
  adminconsoleId: string
}

const mapStateToProps = (
  state: ReduxState,
  { regionId, adminconsoleId }: ConsumerProps,
): StateProps => ({
  loggingSettings: getAdminconsoleLoggingSettings(state, regionId, adminconsoleId),
  fetchLoggingSettingsRequest: fetchAdminconsoleLoggingSettingsRequest(
    state,
    regionId,
    adminconsoleId,
  ),
  patchLoggingSettingsRequest: patchAdminconsoleLoggingSettingsRequest(
    state,
    regionId,
    adminconsoleId,
  ),
})

const mapDispatchToProps = (
  dispatch,
  { regionId, adminconsoleId }: ConsumerProps,
): DispatchProps => ({
  fetchLoggingSettings: () =>
    dispatch(fetchAdminconsoleLoggingSettings({ regionId, adminconsoleId })),

  patchLoggingSettings: (settings: { loggingLevels: PatchLoggingLevels }) =>
    dispatch(patchAdminconsoleLoggingSettings({ regionId, adminconsoleId, ...settings })),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(ZkLoggingSettingsButton)
